import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import discountsApi from '@/features/dashboard/discounts/api/discountsApi.ts';
import { discountsApiQueryKeys } from '@/features/dashboard/discounts/api/discountsApi.queryKeys.ts';
import { DiscountDetailDto } from '@/features/dashboard/discounts/types/DiscountDetailDto.ts';

const useGetDiscount = (discountId: string | undefined) => {
  return useQuery(getDiscountQueryOptions(discountId));
};

export const getDiscountQueryOptions = (
  discountId: string | undefined,
): UseQueryOptions<DiscountDetailDto> => ({
  queryKey: discountsApiQueryKeys.byId(discountId ?? ''),
  queryFn: () => discountsApi.get(discountId!),
  enabled: !!discountId,
});

export default useGetDiscount;
